<template>
  <div>
    <button @click="login" :class="{border: showBorder}" id="appleLoginButton">
      <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg">
      <span v-if="isLogin">Sign in with Apple</span>
      <span v-else>Sign up with Apple</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
      default: 50,
    },
    isLogin: {
      type: Boolean,
      default: false,
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    clientId: process.env.VUE_APP_APPLE_CLIENT_ID,
    scope: process.env.VUE_APP_APPLE_SCOPE,
    redirectURI: process.env.VUE_APP_APPLE_REDIRECT_URI,
    createRedirectURI: process.env.VUE_APP_APPLE_CREATE_REDIRECT_URI,
    state: '',
  }),

  created() {
    const { packId } = this.$route.query;
    if (packId) {
      this.state = packId;
    }
  },

  mounted() {
    this.loadAppleSignInScript();
  },

  methods: {
    // Apple Sign-inスクリプトを読み込み
    loadAppleSignInScript() {
      const script = document.createElement('script');
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      script.onload = this.initAppleSignIn;
      document.head.appendChild(script);
    },
    initAppleSignIn() {
      window.AppleID.auth.init({
        clientId: this.clientId,
        scope: this.scope,
        redirectURI: this.isLogin ? this.redirectURI : this.createRedirectURI,
        state: this.state,
      });
    },
    login() {
      window.AppleID.auth.signIn();
    },
  },
};
</script>

<style lang="scss">
#appleLoginButton {
  border-radius: 100px;
  background-color: #fff;
  color: #111;
  font-size: 22px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  &.border {
    border: 1px solid $baseColor;
  }
  img {
    height: 16px;
    margin-right: 10px;
  }
}
</style>
